import React, { useEffect, useRef, useState } from "react";
import ModalPopup from "../../Common/Modal/Modal";

const CredentialsOtpModal = ({
  show,
  actionType = "view",
  loading = false,
  onClose,
  onVerify,
  onResend,
}) => {
  const otpRefs = useRef([]);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(5 * 60);
  const [showResendOtp, setShowResendOtp] = useState(false);

  useEffect(() => {
    if (!show) return;

    setOtp(["", "", "", "", "", ""]);
    setTimeLeft(5 * 60);
    setShowResendOtp(false);

    setTimeout(() => {
      otpRefs.current[0]?.focus();
    }, 200);
  }, [show]);

  useEffect(() => {
    if (!show || timeLeft <= 0 || showResendOtp) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [show, timeLeft, showResendOtp]);

  useEffect(() => {
    if (timeLeft === 0) {
      setShowResendOtp(true);
    }
  }, [timeLeft]);

const getButtonText = () => {
  if (actionType === "delete") return "Verify & Delete";
  if (actionType === "update") return "Verify & Update";
  if (actionType === "view_for_update") return "Verify & View";
  if (actionType === "sensitive_toggle") return "Verify & Make Non-Sensitive";

  return "Verify & View";
};

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s
      .toString()
      .padStart(2, "0")}`;
  };

  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    if (value && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const updatedOtp = [...otp];
        updatedOtp[index] = "";
        setOtp(updatedOtp);
        return;
      }

      if (index > 0) {
        otpRefs.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pastedOtp = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);

    if (!pastedOtp) return;

    const updatedOtp = ["", "", "", "", "", ""];
    pastedOtp.split("").forEach((digit, index) => {
      updatedOtp[index] = digit;
    });

    setOtp(updatedOtp);
  };

  const handleVerify = () => {
    const otpValue = otp.join("");

    if (otpValue.length !== 6) return;

    onVerify?.(otpValue);
  };

  const handleResendOtp = async () => {
    await onResend?.();

    setOtp(["", "", "", "", "", ""]);
    setTimeLeft(5 * 60);
    setShowResendOtp(false);

    setTimeout(() => {
      otpRefs.current[0]?.focus();
    }, 200);
  };

  return (
    <ModalPopup show={show} onClose={onClose} closeicon={false}>
      <div className="space-y-4">
        <div className="flex justify-between">
          <button
            type="button"
            onClick={onClose}
            className="bg-[#1f4b7f] text-white pl-4 pr-2 py-1 rounded-r-md back-button"
          >
            Back
          </button>

          {/* {!showResendOtp && (
            <p className="text-center text-gray-600">
              Resend OTP in {formatTime(timeLeft)}
            </p>
          )} */}
        </div>

        <h2 className="text-[#1f4b7f] font-semibold text-2xl text-center">
          OTP Verification
        </h2>

        <p className="text-center">
          Enter the 6-digit OTP sent to your registered mobile number.
        </p>

        <div className="flex justify-center gap-3" onPaste={handlePaste}>
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (otpRefs.current[index] = el)}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={digit}
              onChange={(e) => handleOtpChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-10 h-10 border-2 border-gray-400 rounded-md p-2 text-xl text-center"
            />
          ))}
        </div>

        {/* {!showResendOtp ? ( */}
          <button
            type="button"
            disabled={otp.join("").length !== 6 || loading}
            onClick={handleVerify}
            className="bg-[#1f4b7f] text-white px-3 py-1 rounded-md block mx-auto"
          >
            {loading ? "Verifying..." : getButtonText()}
          </button>
        {/* ) : (
          <button
            type="button"
            onClick={handleResendOtp}
            className="bg-[#1f4b7f] text-white px-3 py-1 rounded-md block mx-auto"
          >
            Resend OTP
          </button>
        )} */}
      </div>
    </ModalPopup>
  );
};

export default CredentialsOtpModal;